<template>
  <div>
    <div class="h-topo_pw2" v-show="see" :style="PositionXY">
      
      <div :style="topPannelStyle">
        <div class="h-topo_wytb_topwz" :title='serviceName'>{{$t('服务名称')}}：{{serviceName}}</div>
        <div :style="onOffButton">
          <span @click="click()" class="e-btn-icon icon hero-icon hero-icon-Expand" :title="$t('Common.close')"></span>
        </div>
      </div>
      
      <div :style="bottomPannelStyle" v-if="seeBottom">
        <div class="h-topo_wybox">
          <div class="h-topo_wytb3"></div>
          <div class="h-topo_wytb3">
            <span class="e-btn-icon icon hero-icon hero-icon-detailed"></span>
          </div>
          <div class="h-topo_xq">{{$t('Topo.serveDetail')}}</div>
          <!-- 服务详情下数据面板 -->
          <div id="k8sServicePanelContent" :style="serviceDetail" class="h-topo_content scroll" >
            <ul id='service' class="h-topo_tableheight " v-for="(item, i) in k8sService" >
              <!--<tr>第{{i}}个service:</tr>-->
             <!-- <li>{{$t('Topo.id')}}: {{item.id}}</li> -->
              <li>{{$t('Topo.name')}}: {{item.name}}</li>
              <li v-if="item.children.length > 0" >{{$t('Topo.servicePOD')}}:</li>
              <li v-if="item.children.length > 0">
                <ul id='pod' v-for="(pod, j) in item.children" >     
                	<!--           
					  <li>{{$t('Topo.id')}}: {{pod.id}}</li>
	                  <li>{{$t('Topo.nameSpace')}}: {{pod.namespace}}</li>
	                 -->   
	                  <li>{{$t('Topo.name')}}: {{pod.name}}</li>
	                
	                  <li>{{$t('Topo.runningStatus')}}: {{pod.status}}</li>
	                 	<!-- 
	                  <li>{{$t('Topo.ip')}}: {{pod.ip}}</li>-->
	                  <li  v-if="pod.children.length > 0" >{{$t('Topo.serviceContainer')}}:</li>
	                  <li  v-if="pod.children.length > 0" >
	                    <ul id='containers' v-for="(containers, k) in pod.children">
	                    <!-- 
		                      <li>{{$t('Topo.id')}}: {{containers.id}}</li> -->  
		                      <li>{{$t('Topo.name')}}: {{containers.name}}</li>
		                      <li>{{$t('Topo.cpuUsage')}}: {{containers.cpuUsage}}</li>
		                      <li>{{$t('Topo.memoryUsage')}}: {{containers.memoryUsage}}</li>		                      
		                      <li v-if="containers.children.length > 0" >{{$t('Topo.servicePID')}}:</li>
		                      <li v-if="containers.children.length > 0" >
		                        <ul id='four' v-for="(item, l) in containers.children" >
								<!-- 	<li>{{$t('Topo.id')}}: {{item.id}}</li>  
									
									<li>{{$t('Topo.dockerContainerId')}}: {{item.dockerContainerId}}</li> --> 
									<li>{{$t('Topo.servicePID')}}: {{item.pid}}</li>
									<li>{{$t('Topo.cpuUsage')}}: {{item.cpuUsage}}</li>
									<li>{{$t('Topo.memoryUsage')}}: {{item.memoryUsage}}</li>
								<!--	<li>{{$t('Topo.cmdline')}}: {{item.cmdline}}</li> --> 
		                        </ul>
		                      </li>
	                    </ul>
	                 </li>
                </ul>
              </li>
            </ul>
          </div>
        </div>
        <div :style="alarmButton">
          <button class="e-primary e-btn" @click="alarmShowOperation">{{$t('Alarm.alarm')}}</button>
        </div>
      </div>
    </div>
    <!-- “告警弹窗展示” -->
    <CustomDialog ref="oprDialog" :element="oprSetDialog.element" :styles="oprSetDialog.styles">
      <template v-slot:dialog-content>
        <AlarmShowDialog ref='alarmDetailDialog'></AlarmShowDialog>
      </template>
    </CustomDialog>
  </div>
</template>
<script>
  import CustomDialog from "../../components/common/CustomDialog";
  import AlarmShowDialog from "../../components/topoconfig/AlarmShowDialog";
  import { EventBus } from '../../plugins/eventBus';
  import Table from "../deploymentManagement/serverManagement/Table";
  import {createNamespacedHelpers} from "vuex";
  const { mapGetters, mapActions } = createNamespacedHelpers('topoConfig');

  export default {
    name: "K8sServicePanel",
    components: {
      Table,
      CustomDialog,
      AlarmShowDialog
    },
    computed: {
      ...mapGetters(['physicalNodes', 'logicalNodes', 'getTypeByCode', 'getPhysicalById']),
    },
    data() {
      return {
        id: "",
        PositionXY: '',
        parentId: "",
        type: "",
        see: false,
        seeBottom: false,
        serviceName: "",
        k8sService: [], // k8s数据源
        alarmDetailObj: { id: this.id},
        typeCode: "",
        devInfo: {},
        space1: '&nbsp;&nbsp;',
        topPannelStyle: {
          width: '420px',
          height: '42px',
          background: '#000000',
          borderRadius: '5px',
          opacity: 0.70,
          boxShadow: '2px 2px 8px #4A5962',
        },
        onOffButton: {
          position: 'absolute',
          margin: '7px 365px',
          width: '10px',
          height: '10px',
          cursor: 'pointer',
        },
        // 外层div
        bottomPannelStyle: {
          marginTop: '5px',
          width: '420px',
          height: '500px',
          background: '#000000',
          borderRadius: '5px',
          opacity: '0.70',
          boxShadow: '2px 2px 8px #4A5962',
        },
        serviceDetail: {
          position: 'absolute',
          
          marginTop: '12px',
          color: '#DDDDDD',
          overflow: 'auto',
          overflowX: 'hidden',
          height: '420px',
          width: '420px',
          fontSize: '12px',
        },
        alarmButton: {
          position: 'absolute',
          marginTop: '460px',
          marginLeft: '330px',
        },

        oprSetDialog: {
          element: {
            title: this.$t("Alarm.alarm"),
            target: "#app",
            isClose: true,
            refName: "oprSetDia",
            buttonGroup: [
              {
                click: this.dialogHide,
                buttonModel: { content: this.$t("Topo.cancel") }
              }
            ]
          },
          styles: {
            width: "810px",
            height: "760px",
            model: true,
            visible: false,
          }
        }
      };
    },
    props: ["k8sServiceShow"],
    methods: {
      ...mapActions(['setPhysical', 'addPhysical', 'delPhysicalNodes']),

      panelBoardGetData() {
        let environmentId = 0;
        if (this.parentId) {
          let pNode = this.getPhysicalById(this.parentId);
          if ( (Number(pNode.type) >= 30001 && Number(pNode.type) <= 30010) ) {
            environmentId = this.parentId;
          } else {
            pNode = this.getPhysicalById(pNode.parentid);
            environmentId = pNode.parentid;
          }
        }

        let url = `/lte/ems/env/servicePanel?environmentId=${environmentId}&netElementId=${this.id}`;
        this.axios.get(url).then(response => {
          if (response && response.data.errorCode === "SUCCESS") {
            const result = response.data.resultVal;
            if (result) {
              // this.serviceName = result.serviceName;
              this.k8sService = result.k8sService;
            }
          } else {
            console.log('查询服务失败');
          }
        });
      },

      // 去后台查设备类型
      // queryDevType(typeCode) {
      //   const This = this;
      //   const params = {};
      //   This.$axios.get("/lte/ems/topo/device/devType", params).then(response => {
      //     if (response.data === undefined) {
      //       return;
      //     }
      //     if (response.data.errorCode === "SUCCESS") {
      //       This.typeData = response.data.resultVal;
      //       console.log("typeData",This.typeData)
      //       for (let index in This.typeData) {
      //         if (This.typeData[index].typeCode == typeCode) {
      //           this.typeCode = This.typeData[index].nameKey;
      //           this.icon = This.typeData[index].icon;
      //         }
      //       }
      //     } else if(response.status === 401) {
      //       EventBus.$emit('toast', {type: 'error', content: this.$t('System.loginAgain')});
      //     } else {
      //       This.typeData = [];
      //       EventBus.$emit('toast', {type: 'error', content: response.data.errorString});
      //     }
      //   });
      // },
      click() {
        this.seeBottom = !this.seeBottom;
        this.see = !this.see;
      },

      alarmShowOperation() {
        const alarmId = this.id;
        let ids = [alarmId];
        this.$axios.get(`/lte/ems/topo/netElement/${alarmId}`).then(response => {
          if (!response.data) {
            return;
          }
          if (response && response.status === 200 && response.data.errorCode === "SUCCESS") {
            if (response.data && response.data.resultVal.length > 0) {
              ids = ids.concat(response.data.resultVal);
            }
          } else if(response.status === 401) {
            EventBus.$emit('toast', {type: 'error', content: this.$t('System.loginAgain')});
          } else {
            EventBus.$emit('toast', {type: 'error', content: response.data.errorString});
          }
          this.$refs.alarmDetailDialog.beforeMount(ids);
          this.$refs.oprDialog.show();
        });
      },
      dialogHide() {
        this.$refs.oprDialog.clear();
        this.$refs.oprDialog.close();
      }
    },

    mounted() {},
    watch: {
      k8sServiceShow: {
        handler: function(newVal, oldVal) {
          
	          this.see = newVal.seeObj;
	          this.seeBottom = newVal.seeBottomObj;
	          this.id = newVal.idObj;
	          this.parentId = newVal.parentId;
	          this.type = newVal.typeObj;
	          this.serviceName = newVal.serviceName;
	          
	          if (newVal.onlineObj === 1) {
	            this.online='h-pm-iconOnline';
	          } 
	          else if(newVal.onlineObj === 0) {
	            this.online='h-pm-iconOffline';
	          }
	          this.PositionXY = newVal.PositionXY;
	          this.panelBoardGetData(); // 请求后台查询信息
			
			  if(document.getElementById("k8sServicePanelContent") != null )
          		document.getElementById('k8sServicePanelContent').scrollTop = 0; 	//-- scroll to top  
        },
        deep: true
      }
    }
  };
</script>
<style>

</style>
